(function () {
  function openPopup(popup) {
    popup.hidden = false;
    document.body.style.overflow = "hidden";
    popup.querySelector(".label-popup__close")?.focus();
  }

  function closePopup(popup) {
    popup.hidden = true;
    document.body.style.overflow = "";
    const id = popup.id.replace("wd-label-popup-", "wd-label-trigger-");
    document.getElementById(id)?.focus();
  }

  function onDocumentClick(event) {
    const trigger = event.target.closest(".wd-product-label__trigger");
    if (trigger) {
      const popup = document.getElementById(
        trigger.id.replace("wd-label-trigger-", "wd-label-popup-"),
      );
      if (popup) {
        event.preventDefault();
        openPopup(popup);
      }
      return;
    }

    const closeBtn = event.target.closest(".label-popup__close");
    if (closeBtn) {
      const popup = closeBtn.closest(".wd-product-label__popup");
      if (popup) closePopup(popup);
      return;
    }

    const popup = event.target.closest(".wd-product-label__popup");
    if (popup && event.target === popup) {
      closePopup(popup);
    }
  }

  function onDocumentKeydown(event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".wd-product-label__popup:not([hidden])").forEach(closePopup);
  }

  function onTriggerKeydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    const trigger = event.target.closest(".wd-product-label__trigger");
    if (!trigger) return;
    event.preventDefault();
    const popup = document.getElementById(
      trigger.id.replace("wd-label-trigger-", "wd-label-popup-"),
    );
    if (popup) openPopup(popup);
  }

  document.addEventListener("click", onDocumentClick);
  document.addEventListener("keydown", onDocumentKeydown);
  document.addEventListener("keydown", onTriggerKeydown);
})();
